module.exports = coupons;